<template>
  <div class="hero-wrapper">

    <svg
      width="600"
      height="600"
      viewBox="0 0 600 600"
      class="svg-blob-hero"
      xmlns="http://www.w3.org/2000/svg">
      <g transform="translate(300,300)">
        <path d="M93.5,-127C139.9,-94.9,209.3,-92.7,221.5,-68.8C233.6,-44.8,188.6,0.9,152.4,30C116.1,59.2,88.6,71.6,64.7,104.4C40.8,137.1,20.4,190,-15.8,211.8C-51.9,233.5,-103.8,223.9,-145.4,196.9C-186.9,169.9,-218,125.4,-206.7,85C-195.3,44.5,-141.4,8,-109.7,-18.9C-77.9,-45.9,-68.4,-63.4,-53.8,-105.8C-39.2,-148.3,-19.6,-215.6,2,-218.3C23.5,-221,47,-159.1,93.5,-127Z" fill="#fff" />
      </g>
    </svg>

    <div class="inc-500-banner" v-if="videoSrc">
      <!-- <img src="../../../assets/inc-500.png" alt="Inc 500"> -->
      <!-- <span class="desktop-note">MikMak ranks no. 222 on the 2019 Inc. 5000 fastest growing companies in America list!. <a href="https://www.inc.com/profile/mikmak" target="new">Read all about it.</a> </span> -->
      <!-- <span class="mobile-note">MikMak ranks 222 on the Inc. 5000! <a href="https://www.inc.com/profile/mikmak" target="new">Read more.</a> </span> -->

      <!-- <span class="desktop-note">MikMak has released our 2019 eCommerce Holiday Guide. <a href="/holiday-2019">Download it today.</a> </span>
      <span class="mobile-note">MikMak has released our 2019 Holiday Guide. <a href="/holiday-2019">Download it now.</a> </span> -->

      <span class="desktop-note">🍾 MikMak launches Attach for alcohol eCommerce  <a href="/alcohol">Learn more here. </a> </span>
      <span class="mobile-note">🍾 MikMak launches Attach for alcohol eCommerce  <a href="/alcohol">Learn more here. </a> </span>
    </div>

    <!-- TEXT CONTENT -->
    <div class="hero-text">

      <h1 class="hero-text-main">{{ heroTextMain }}</h1>
      <h3 class="hero-text-sub">{{ heroTextSub }}</h3>

      <div class="hero-get-demo-box">
        <input class="hero-get-demo-input" type="text" placeholder="enter your email" v-on:keyup="keyListener($event)">
        <a href="#contact-footer" class="hero-get-demo-button" v-on:click="getDemoEvent">
          get a demo
        </a>
      </div>

    </div>

    <!-- PHONE AND BUTTONS CONTENT -->
    <div class="phone-and-buttons">

      <!-- video -->
      <div class="hero-main-video">
        <video v-if="videoSrc" :src="videoSrc" playsinline loop muted autoplay></video>
      </div>

      <!-- device -->
      <div class="hero-main-image"></div>

      <!-- atc buttons -->
      <div class="atc-button-image-wrapper">
        <img src="../../../assets/winter-2019/checkout-amazon.png" class="atc-button-amazon atc-button-image">
        <img src="../../../assets/winter-2019/checkout-walmart.png" class="atc-button-walmart atc-button-image">
        <img src="../../../assets/winter-2019/checkout-target.png" class="atc-button-target atc-button-image">
      </div>
    </div>

  </div>
</template>

<script>

import eventDispatcher from '../../../events/dispatch'

export default {
  data() {
    return {
      heroTextMain: 'Shoppable media designed by the social video generation',
      heroTextSub: 'MikMak shortens the path to purchase at your main eRetailers and direct-to-consumer websites.',
      atcButtonHeader: 'Check out on Amazon',
      atcButtonSubHeader: '$11.99 on Amazon.com',
      videoIndex: 0,
      videoSrc: 'https://s3.amazonaws.com/attach-videos/Ai9MWzdNRJCjfyS6U0rd_new_hero_sm.mov',
      allVideos: [
        'https://s3.amazonaws.com/attach-videos/956838_RTD14oz_1-sm.mp4', // Nesquik
        'https://s3.amazonaws.com/attach-videos/WiGElHSHRde9FxqSxbMX_FRO_NO%20GRAPHICS.mp4', // Shea
        'https://s3.amazonaws.com/attach-videos/sIP4VS5eTdKVFm3x7WNU_V8_Red_FillingSnack%20FaceBook_9x16-REV0_190228.mp4', // V8
        'https://s3.amazonaws.com/attach-videos/RqSTCtY5Ria4qrnRKlWa_EsteeLauder_022719_04b.mp4', // Estee
      ],
      logos: [
        'google',
        'instagram',
        'facebook',
        'snapchat',
        'amazon',
        'walmart',
        'target',
        'instacart',
        'kroger',
        'youtube',
        'twitter',
        'pinterest'
      ]
    }
  },
  mounted() {
    if (window.navigator.appVersion.search('iPad') >= 0) this.isIpad = true
    var v = document.querySelectorAll('video');
    for (var i = 0; i < v.length; i++) {
      if (window.navigator.platform !== 'MacIntel') {
        window.enableInlineVideo(v[i])
      }
    };
    // this.alternateVideoSrc()
  },
  methods: {
    getDemoEvent() {
      eventDispatcher('requestDemoClicked', {
        sourceOfDemo: 'Main Hero Button'
      })
    },
    alternateVideoSrc() {
      if (this.videoIndex >= this.allVideos.length) this.videoIndex = 0
      let vid = this.allVideos[this.videoIndex]
      this.videoSrc = vid

      setTimeout(() => {
        this.videoIndex++
        this.alternateVideoSrc()
      }, 15000)

    },
    getSocialImageUrl(name) {
      var images = require.context('../../../assets/social-logos/')
      return images(`./${name}.png`)
    },
    keyListener(e) {
      let email = e.srcElement.value
      let emailField = document.getElementById('contact-form-email-address')
      if (emailField) emailField.value = email
    }
  },
  computed: {},
  watch: {}
}
</script>

<style scoped>

.hero-text {
  display: block;
  margin-top: 120px;
  margin-left: 10%;
  width: 600px;
  font-size: 32px;
  color: #1D2229;
}

.hero-text-main {
  font-family: 'Raleway', sans-serif;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.18);
  font-weight: normal;
  font-size: 48px;
  line-height: 56px;
}

.hero-text-sub {
  margin: 4px;
  padding: 0;
  font-size: 18px;
  font-weight: normal;
  font-family: "Work Sans", sans-serif;
  margin-bottom: 32px;
  max-width: 80%;
  line-height: 24px;
}

.hero-main-image {
  display: block;
  position: absolute;
  top: -167px;
  z-index: 4;
  right: 107px;
  animation: atcFloat 20s ease-in-out infinite;
  height: 692px;
  width: 387px;
  background-size: 397px;
  background-repeat: no-repeat;
  background-position: center center;
  background-image: url('../../../assets/winter-2019/hero-phone-14.png');
}

.hero-main-video {
  display: block;
  position: absolute;
  z-index: 1;
  top: 0;
  right: 0;
}

.hero-main-video video {
  display: block;
  width: 284px;
  margin-right: 161px;
  margin-top: -64px;
}

.atc-button {
  font-family: SFUIText-Regular,avenir next,avenir,helvetica,helvetica neue,Ubuntu,segoe ui,arial,sans-serif;
  display: block;
  background: blue;
  color: white;
  width: 300px;
  border-radius: 4px;
  position: absolute;
  z-index: 10;
  top: 331px;
  right: 181px;
  font-size: 19px;
  text-align: center;
  padding: 8px;
  animation: float 12s ease-in-out infinite;
  transform: rotate(2deg) !important;
}

.atc-button-heading {
  font-size: 16px;
  display: block;
}

.atc-button-subheading {
  font-size: 14px;
  display: block;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.atc-button-image-wrapper {
  display: block;
  position: absolute;
  z-index: 7;
  top: 212px;
  right: 162px;
}

.atc-button-amazon {
  animation: atcFloat 12s ease-in-out infinite;
  margin-left: -28px;
  margin-bottom: -10px;
}

.atc-button-walmart {
  animation: atcFloat 8s ease-in-out infinite;
  margin-left: -12px;
  margin-bottom: -12px;
}

.atc-button-target {
  animation: atcFloat 12s ease-in-out infinite;
  transform: rotate(2deg) !important;
}

.atc-button-image {
  width: 380px;
  display: block;
}

.hero-get-demo-box {
  display: block;
  width: 90%;
  /* border: 2px solid #005da2; */
  border: 2px solid #31c4a8;
  border-radius: 4px;
  white-space: nowrap;
  text-align: center;
  padding: 0;
  margin: 0;
  overflow: hidden;
  font-family: "Work Sans", sans-serif;
}

.hero-get-demo-input,
.hero-get-demo-button {
  display: inline-block;
  border: none;
  font-size: 24px;
  width: 50%;
  text-align: center;
  font-size: 16px !important;
}

.hero-get-demo-button {
  background: #31c4a8;
  color: white;
  padding: 16px 0;
  cursor: pointer;
  text-decoration: none;
  cursor: pointer;
  /* background: #005da2; */
}

.hero-get-demo-input {
  font-family: "Work Sans", sans-serif;
  margin: 0 auto;
  padding: 8px 0;
  background: none;
  outline: none;
}

.hero-get-demo-input::placeholder {
  color: #c7c7c7;
}

@media only screen and (max-width: 1250px) {
  .hero-get-demo-box {
    height: 40px;
  }

  .hero-get-demo-input,
  .hero-get-demo-button {
    vertical-align: middle;
    font-size: 20px;
    padding: 0;
    margin-top: -26px;
  }
}

@media only screen and (max-width: 450px) {
  .hero-get-demo-input {
    display: none;
  }
  .hero-get-demo-box {
    border: none;
    overflow: visible;
    height: 70px;
  }
  .hero-get-demo-button {
    margin: 0 auto;
    width: 100%;
    border-radius: 4px;
    box-shadow: 0 2px 2px rgba(0,0,0,0.2);
    text-transform: uppercase;
    letter-spacing: 1px;
    padding: 4px 0;
  }
}


@keyframes float {
	0% {
		box-shadow: 0 5px 15px 0px rgba(0,0,0,0.2);
		transform: translatey(0px);
	}
	50% {
		box-shadow: 0 25px 15px 0px rgba(0,0,0,0.1);
		transform: translatey(-4px);
	}
	100% {
		box-shadow: 0 5px 15px 0px rgba(0,0,0,0.2);
		transform: translatey(0px);
	}
}

@keyframes atcFloat {
	0% {
		transform: translatey(0px);
	}
	50% {
		transform: translatey(-7px);
	}
	100% {
		transform: translatey(0px);
	}
}

/* Specific styles */
.amazon-social-logo {
  z-index: 2;
  right: 68px;
  top: 109px;
  animation: float 6s ease-in-out infinite;
}

.instagram-social-logo {
  z-index: 2;
  right: 100px;
  top: 309px;
  animation: float 16s ease-in-out infinite;
}

.facebook-social-logo {
  z-index: 5;
  right: 269px;
  top: 483px;
  animation: float 4s ease-in-out infinite;
}

.snapchat-social-logo {
  z-index: 5;
  right: 474px;
  top: 430px;
  animation: float 8s ease-in-out infinite;
}

.google-social-logo {
  z-index: 5;
  right: 25px;
  top: 473px;
  animation: float 5s ease-in-out infinite;
}

.target-social-logo {
  z-index: 5;
  right: 116px;
  top: 421px;
  animation: float 8s ease-in-out infinite;
}

.walmart-social-logo {
  z-index: 5;
  right: 32px;
  top: 220px;
  animation: float 10s ease-in-out infinite;
}

.kroger-social-logo {
  z-index: 3;
  right: 445px;
  top: 40px;
  animation: float 20s ease-in-out infinite;
}

.instacart-social-logo {
  z-index: 5;
  right: 395px;
  top: 497px;
  animation: float 3s ease-in-out infinite;
}

.pinterest-social-logo {
  z-index: 5;
  right: -7px;
  top: 32px;
  animation: float 5s ease-in-out infinite;
}

.twitter-social-logo {
  z-index: 5;
  right: 11px;
  top: 364px;
  animation: float 8s ease-in-out infinite;
}

.youtube-social-logo {
  z-index: 5;
  right: 532px;
  top: 109px;
  animation: float 8s ease-in-out infinite;
}

.svg-blob-hero {
  display: block;
  position: absolute;
  z-index: -1;
  right: 0;
  top: -135px;
  transform: scale(1.4);
}

@media only screen and (max-width: 1250px) {
  .hero-text {
    width: 500px;
    font-size: 28px;
    line-height: 63px;
  }
}

@media only screen and (max-width: 1200px) {
  .hero-text {
    width: 450px;
    font-size: 24px;
    line-height: 58px;
  }
}

@media only screen and (max-width: 1000px) {
  .phone-and-buttons {
    display: none;
  }
  .hero-text {
    margin: 0 auto;
    margin-top: 120px;
    width: 80%;
  }
  .hero-text-sub {
    margin: 24px auto;
  }
  .hero-wrapper {
    display: block;
    margin: 0 auto;
    width: 80%;
    text-align: center;
  }
  .hero-get-demo-box {
    margin: 0 auto;
    width: 400px;
  }
}

@media only screen and (max-width: 600px) {
  .phone-and-buttons {

  }
  .hero-text {
    width: 90%;
  }
  .hero-text-main {
    /* width: 95%; */
    font-size: 32px;
    line-height: 32px;
  }
  .hero-text-sub {
    font-size: 16px;
    line-height: 20px;
  }
  .hero-wrapper {
    width: 100%;
  }
  .hero-get-demo-box {
    width: 100%;
  }
  .hero-get-demo-button {
    background: linear-gradient(135deg, #24af94 0%,#31c4a8 69%,#19d09d 100%);
    padding: 0px;
    border: none;
  }
}

.inc-500-banner {
  top: 56px;
  position: absolute;
  z-index: 6;
  background: #809bef;
  padding: 6px;
  text-align: center;
  font-size: 12px;
  color: white;
  left: 0;
  right: 0;
}

.inc-500-banner .desktop-note {
  display: inline-block;
}

.inc-500-banner .mobile-note {
  display: none;
}

@media only screen and (max-width: 1000px) {
  .inc-500-banner .desktop-note {
    display: none;
  }
  .inc-500-banner .mobile-note {
    display: inline-block;
  }
}


.inc-500-banner img {
  height: 25px;
}

.inc-500-banner span {
  display: inline-block;
  vertical-align: top;
  margin: 6px 16px;
}

.inc-500-banner a {
  margin-left: 8px;
  color: #ffdd02;
}

/* .inc-black {
  font-weight: bold;
  color: black;
}

.inc-yellow {
  font-weight: bold;
  color: yellow;
}

.inc-red {
  font-weight: bold;
  color: red;
}

.inc-blue {
  font-weight: bold;
  color: blue;
} */

</style>



// WEBPACK FOOTER //
// HeroContent.vue?1c43a3e4